enum SecurityCheckupCohort {
    COMPLETE_RECOVERY_MULTIPLE = 'COMPLETE_RECOVERY_MULTIPLE',
    COMPLETE_RECOVERY_SINGLE = 'COMPLETE_RECOVERY_SINGLE',
    ACCOUNT_RECOVERY_ENABLED = 'ACCOUNT_RECOVERY_ENABLED',
    NO_RECOVERY_METHOD = 'NO_RECOVERY_METHOD',
}

export default SecurityCheckupCohort;
